import { whyUsContent } from "@/app/content/landingContent";

export function WhyUsSection() {
  return (
    <section
      id="why-us"
      className="py-20 md:py-24 px-6 bg-gray-50"
      aria-labelledby="why-us-heading"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 max-w-3xl">
          <h2
            id="why-us-heading"
            className="text-[clamp(1.875rem,4vw,3rem)] text-slate-900 mb-6 tracking-tight font-bold"
          >
            {whyUsContent.heading}
          </h2>
          <p className="text-[clamp(1.125rem,2vw,1.25rem)] text-slate-600 leading-relaxed max-w-prose">
            {whyUsContent.description}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_400px] gap-12 lg:gap-16 items-start">
          {/* Points — divider list, no icons */}
          <div className="divide-y divide-gray-200">
            {whyUsContent.points.map((point) => (
              <div key={point.title} className="py-7 first:pt-0 last:pb-0">
                <h3 className="text-lg md:text-xl text-slate-900 mb-2 font-semibold leading-snug">
                  {point.title}
                </h3>
                <p className="text-base md:text-lg text-slate-600 leading-relaxed">
                  {point.text}
                </p>
              </div>
            ))}
          </div>

          {/* Metrics panel */}
          <div className="bg-slate-900 p-9 md:p-11 rounded-3xl text-white lg:sticky lg:top-8">
            <div className="space-y-7">
              {whyUsContent.metrics.map((metric) => (
                <div
                  key={metric.value}
                  className="border-l-[3px] border-[#004f4f] pl-5"
                >
                  <dl>
                    <dt className="text-[clamp(1.375rem,2.5vw,1.75rem)] font-bold mb-1 tabular-nums">
                      {metric.value}
                    </dt>
                    <dd className="text-slate-400 text-sm leading-relaxed">
                      {metric.description}
                    </dd>
                  </dl>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
